export default __webpack_public_path__ + "static/media/Pdf_icon.0c6f31f8.svg";